import React, { useEffect, useState, useRef } from 'react';
import Trade from './components/trade';

export default function Content() {
  const [planeY, setPlaneY] = useState(150);
  const [velocity, setVelocity] = useState(0);
  const [obstacleX, setObstacleX] = useState(300);
  const [gapTop, setGapTop] = useState(150);
  const [gameOver, setGameOver] = useState(false);
  const [score, setScore] = useState(0);
  const gameContainerHeight = 384; // Tailwind h-96 in px
  const planeX = 50;
  const obstacleWidth = 50;
  const gap = 120;
  const gravity = 0.3;
  const frameInterval = 33; // ~30 FPS
  const framesRef = useRef(0);

  // Prevent arrow keys from scrolling the window
  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        jump();
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Main game loop
  useEffect(() => {
    let intervalId;
    if (!gameOver) {
      intervalId = setInterval(() => {
        framesRef.current += 1;

        // Gravity effect
        setPlaneY(prev => prev + velocity);
        setVelocity(prev => prev + gravity);

        // Move obstacle
        setObstacleX(prev => {
          if (prev < -obstacleWidth) {
            // Reset obstacle
            return 300;
          }
          return prev - 3;
        });

        // Collision detection
        setPlaneY(prevY => {
          if (prevY < 0 || prevY + 30 > gameContainerHeight) {
            setGameOver(true);
          }
          return prevY;
        });

        // If horizontally aligned
        if (obstacleX < planeX + 30 && obstacleX + obstacleWidth > planeX) {
          // If plane is outside gap
          if (planeY < gapTop || planeY + 30 > gapTop + gap) {
            setGameOver(true);
          }
        }

        // Every 30 frames = 1 second approx
        if (framesRef.current % 30 === 0) {
          setScore(s => (gameOver ? s : s + 1));
        }
      }, frameInterval);
    }
    return () => clearInterval(intervalId);
  }, [gameOver, obstacleX, planeY]);

  // Randomize gap position whenever the obstacle resets
  useEffect(() => {
    if (obstacleX === 300 && !gameOver) {
      setGapTop(Math.floor(Math.random() * 150) + 50);
    }
  }, [obstacleX, gameOver]);

  function jump() {
    if (!gameOver) {
      setVelocity(-5);
    }
  }

  function restart() {
    setPlaneY(150);
    setVelocity(0);
    setObstacleX(300);
    setGapTop(150);
    setGameOver(false);
    setScore(0);
    framesRef.current = 0;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <header className="bg-black px-4 pt-2 pb-0 fixed top-0 left-0 right-0 z-10 well flex justify-between items-center cyber-razor-bottom">
        <h1>Beenz</h1>
        <a
          className="tooltip"
          href="https://dappslap.ai/tokens/9sbrLLnk4vxJajnZWXP9h5qk1NDFw7dz2eHjgemcpump"
          target="_blank"
          rel="noreferrer"
        >
          <div className="vaporwave-button large">
            <img
              src="https://apps.dappslap.ai/themes/vaporwave/img/dappslap.svg"
              alt="dappslap"
            />
          </div>
          <span className="tooltiptext diamond-corner-box">
            <div className="top-right"></div>
            <div className="bottom-left"></div>
            This Beenz offering was made on dappslap.ai
          </span>
        </a>
      </header>
      <main
        className="flex-grow mt-20 px-4 py-2 flex flex-col items-center"
        onClick={() => jump()}
        onTouchStart={() => jump()}
      >
        <div className="relative bg-blue-300 w-full max-w-md h-96 overflow-hidden flex items-center justify-center">
          {!gameOver && (
            <>
              <img
                src="https://ipfs.io/ipfs/QmVzFTXUfXgQmnMZngYccgTXju9RyjG3sSVWvPcgkVKrPg"
                alt="plane"
                className="absolute w-10"
                style={{ top: planeY, left: planeX }}
              />
              <div
                className="absolute bg-green-700"
                style={{
                  left: obstacleX,
                  top: 0,
                  width: obstacleWidth,
                  height: gapTop
                }}
              ></div>
              <div
                className="absolute bg-green-700"
                style={{
                  left: obstacleX,
                  top: gapTop + gap,
                  width: obstacleWidth,
                  height: gameContainerHeight - (gapTop + gap)
                }}
              ></div>
            </>
          )}
          {gameOver && (
            <div className="absolute flex flex-col items-center text-center">
              <div className="text-2xl font-bold text-red-600 mb-2">
                game over
              </div>
              <button
                className="bg-black text-white px-4 py-2 rounded"
                onClick={restart}
              >
                Restart
              </button>
            </div>
          )}
        </div>
        <div className="text-xl font-bold mt-4">Score: {score}</div>
        <div className="max-w-lg w-full p-6 rounded-lg shadow-md mb-8">
          <Trade />
        </div>
      </main>
      <div className="divider w-full h-6"></div>
      <div className="w-full p-8 flex justify-stretch dev-banner">
        <div className="flex-1 text-center p-4 ">
          Dev: 92BhJX3oRagnLG8wxvpp2usdKk9dd2FWqMeWGQ5Uc484
        </div>
      </div>
      <footer className="bg-black p-4 pt-1 flex justify-center items-center gap-2 well relative cyber-razor-top">
        <a
          href="https://dappslap.ai/tokens/9sbrLLnk4vxJajnZWXP9h5qk1NDFw7dz2eHjgemcpump"
          target="_blank"
          rel="noreferrer"
          className="vaporwave-button"
        >
          <img
            src="https://apps.dappslap.ai/themes/vaporwave/img/dappslap.svg"
            alt="dappslap"
          />
        </a>
      </footer>
    </div>
  );
}